import {CyClass} from "../../../../../common/cy-classes";
import {Button} from "../../../../basic-ui-components/button/base/button.component";
import {useServices} from "../../../../react-hooks/use-services.hook";

export const ClientSettingsTriggerComponent = () => {
    const services = useServices();

    const clickHandler = () => {
        services.clientSettings.toggleClientSettingsOpen();
        services.clientSettings.sendOrbitUserFlowAnalytics('Open_Settings');
    }


    return (
        <Button
            className={CyClass('cy-header-client-settings-button')}
            preset="flatStroked"
            icon={{Component: services.theme.currentTheme.icons.gearWheelIcon}}
            onClick={clickHandler}
            margin="0 0.4rem"
        />
    )
}